module.exports = __webpack_public_path__ + "media/home1-left.82f9a062.mp4";